export default "__VITE_ASSET__XPqYxbvu__"